















import { Component, Prop, Vue } from 'vue-property-decorator';
import { CalendarEntry } from '@/utils/calendar-dates';
import { namespace } from 'vuex-class';
import { dateToYYYYMMDD } from '@/utils/date-helpers';
import { playSound } from '@/utils/playSound';

const puzzle = namespace('Puzzle');

const ui = namespace('UI');

@Component
export default class CalendarDay extends Vue {
  @puzzle.State
  private date!: string;

  @puzzle.State
  private completedDates!: string[];

  @ui.Action
  private openChangeDatePopup!: () => void;

  @Prop() private dayEntry!: CalendarEntry;

  get completedPuzzle() {
    return this.completedDates.includes(dateToYYYYMMDD(this.dayEntry.date));
  }

  get currentPuzzle() {
    return this.date === dateToYYYYMMDD(this.dayEntry.date);
  }

  get clickable() {
    return this.dayEntry.puzzleAvailable && this.dayEntry.currentMonth;
  }

  public handleClick(): void {
    playSound('buttonClickSound');
    if (!this.dayEntry.puzzleAvailable) return;
    this.$emit('pickedTempDate', this.dayEntry.date);
    this.openChangeDatePopup();
  }
}
